import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoading,
  getData,
  getEntryList,
  getConceptList,
  getImputationList,
  getDistributionList,
  getConceptsWithoutImputation
} from "../selectors";
import { RESET_STATE } from "../actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import {
  deleteAccountingImputationsAction,
  duplicateAccountingImputationsAction,
  exportAccountingImputationsAction,
  getAccountingImputationsAction,
} from "../actions";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { getLocalizedString } from "@icarius-localization/strings";

const useImputations = () => {

  const [viewDialogIsOpen, setViewDialogIsOpen] = useState(false);
  const [editDialogIsOpen, setEditDialogIsOpen] = useState(false);
  const [createDialogIsOpen, setCreateDialogIsOpen] = useState(false);
  const [duplicateDialogIsOpen, setDuplicateDialogIsOpen] = useState(false);
  const [importDialogIsOpen, setImportDialogIsOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null); //seleccionado para editar

  const dispatch = useDispatch();
  const data = useSelector(getData);
  const isLoading = useSelector(getLoading);
  const entryList = useSelector(getEntryList);
  const conceptList = useSelector(getConceptList);
  const imputationList = useSelector(getImputationList);
  const distributionList = useSelector(getDistributionList);
  const conceptsWithoutImputation = useSelector(getConceptsWithoutImputation);

  useEffect(() => {
    dispatch(getAccountingImputationsAction());
    return () => { dispatch({ type: RESET_STATE }) }
  }, [dispatch])

  const handleOpenDeleteDialog = (gridRef) => {
    let documents = gridRef.api.getSelectedRows();

    dispatch(openDialogAction({
      title: getLocalizedString("atention"),
      msg: getLocalizedString("doYouWantToDeletePosting"),
      onConfirm: () => handleDelete(documents),
    }));
  }

  const handleOpenCreateDialog = (gridRef) => {
    let documents = gridRef.api.getSelectedRows();
    if (documents.length > 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRecordOrNone"), severity: "warning" }));
      return;
    }

    setSelectedDocument(documents.length === 1 ? documents[0] : null);
    setCreateDialogIsOpen(true);
  }

  const handleOpenEditDialog = (gridRef) => {
    let documents = gridRef.api.getSelectedRows();
    if (documents.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
      return;
    }

    setSelectedDocument(documents[0]);
    setEditDialogIsOpen(true);
  }

  const handleOpenDuplicateDialog = (gridRef) => {
    let documents = gridRef.api.getSelectedRows();
    if (documents.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
      return;
    }

    setSelectedDocument(documents[0]);
    setDuplicateDialogIsOpen(true);
  }

  const handleCloseCreateEditDuplicateDialog = () => {
    setCreateDialogIsOpen(false);
    setEditDialogIsOpen(false);
    setDuplicateDialogIsOpen(false);
    setSelectedDocument(null);
  }

  const handleDelete = (rows) => {
    dispatch(deleteAccountingImputationsAction({ codes: rows.map((row) => row.internalCode) }));
  }

  const handleDuplicate = (dataToSend) => {
    dispatch(duplicateAccountingImputationsAction({ internalCode: selectedDocument.internalCode, ...dataToSend }))
      .then(res => {
        if (res?.status === 200) {
          handleCloseCreateEditDuplicateDialog();
        }
      })
  }

  const handleOpenViewDialog = () => {
    setViewDialogIsOpen(true);
  }

  const handleCloseViewDialog = () => {
    setViewDialogIsOpen(false);
  }

  const handleOpenImportDialog = () => {
    setImportDialogIsOpen(true);
  }

  const handleCloseImportDialog = () => {
    setImportDialogIsOpen(false);
  }

  const handleExport = () => { 
    dispatch(exportAccountingImputationsAction());
  }

  const state = {
    duplicateDialogIsOpen,
    editDialogIsOpen,
    createDialogIsOpen,
    selectedDocument,
    viewDialogIsOpen,
    importDialogIsOpen,
  }

  const handlers = {
    handleDelete,
    handleDuplicate,
    handleOpenDeleteDialog,
    handleOpenCreateDialog,
    handleOpenEditDialog,
    handleOpenDuplicateDialog,
    handleCloseCreateEditDuplicateDialog,
    handleOpenViewDialog,
    handleCloseViewDialog,
    handleOpenImportDialog,
    handleCloseImportDialog,
    handleExport,
  }

  return {
    data,
    entryList,
    conceptList,
    imputationList,
    distributionList,
    conceptsWithoutImputation,
    isLoading,
    state,
    handlers
  }
}

export default useImputations;